import { Component, inject, output } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { FloatLabelModule } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { AuthService } from '../../_core/auth.service';
import { BrandingService } from '../../_core/branding.service';
import { catchError, finalize, of, tap } from 'rxjs';

@Component({
  selector: 'app-recovery-password',
  imports: [
    ButtonModule,
    CardModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    FloatLabelModule,
    MessageModule,
    ReactiveFormsModule,
  ],
  templateUrl: './recovery-password.html',
  styleUrl: './recovery-password.scss',
})
export class RecoveryPassword {
  private $auth = inject(AuthService);
  public $branding = inject(BrandingService);
  readonly title = inject(Title).setTitle('Oficina Virtual - Recuperar contraseña');
  public emailCtrl: FormControl = new FormControl('', Validators.email);
  public submitted: boolean = false;
  public error: string = '';

  public navigateTo = output<string>();

  public submit(): void {
    this.submitted = true;
    if (this.emailCtrl.valid) {
      this.$auth
        .forgotPassword(this.emailCtrl.value)
        .pipe(
          tap(() => {
            this.error = '';
            this.submitted = false;
            // this.navigateTo.emit('');
          }),
          catchError((err) => {
            this.error =
              err?.error?.message || 'Ha ocurrido un error. Por favor, inténtelo de nuevo.';
            return of(null);
          }),
          finalize(() => {
            this.submitted = false;
          }),
        )
        .subscribe();
    } else {
      this.submitted = false;
      this.error = 'Por favor, ingrese un correo electrónico válido.';
    }
  }
}
